import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Section, Container, Image } from 'components/atoms';
import { PSPMarkdownContent, SectionHeader, Card } from 'components/molecules';

import './CardBlockSection.scss';

const CardBlockSection = ({ props, theme = 'light' }) => {
	const color = theme === 'dark' ? 'white' : 'black';
	const {
		title,
		content,
		suffix,
		prefix,
		type,
		description = '',
		additionalProps = {},
		pageType,
	} = props;
	return (
		<Section className={` ${theme}`}>
			<SectionHeader
				title={title}
				titleProps={{
					className: `card-block-section__header-title ${
						pageType === 'SGP' && type === 'three-panel'
							? 'custom-header-padding'
							: ''
					}`,
				}}
				suffix={suffix}
				prefix={prefix}
				contentAlign="text-left"
				description={description}
				additionalProps={additionalProps}
			/>
			<Container
				className={classnames(
					'card-block-section',
					`card-block-section--${type}`,
				)}
			>
				{content &&
					content.map((item, index) => (
						<Card
							className={classnames(
								'card-block-section__card',
								`card-block-section__card--${type}`,
							)}
							key={`card-block-${index}`}
						>
							{item.description && (
								<div>
									<PSPMarkdownContent
										content={item.description}
										additionalProps={{
											paragraph: { color: 'black' },
											heading: {
												className: `card-block-section__card-title`,
											},
										}}
									/>
								</div>
							)}
							{item.image && (
								<Image
									width={60}
									src={item.image}
									alt={item.title || `card-image-${index}`}
								/>
							)}
						</Card>
					))}
			</Container>
		</Section>
	);
};

CardBlockSection.propTypes = {
	content: PropTypes.arrayOf(
		PropTypes.shape({
			image: PropTypes.string,
			title: PropTypes.string,
			Description: PropTypes.string,
		})
	).isRequired,
	theme: PropTypes.string,
	className: PropTypes.string,
	pageType: PropTypes.string,
};

export default CardBlockSection;
